import { ColorProgressProps, MapChartProps } from "./interface";

const DEFAULT_MAP_COLOR = ['#f2f2f2', '#d7e7fd', '#bccefb', '#a0b6fa', '#839df8', '#6585f7', '#4970e3']

export const DEFAULT_MAP_PROPS: MapChartProps = {
  data: null,
  mapColor: DEFAULT_MAP_COLOR,
  mapColorV: null,
  className: null,
  style: {},
  height: 390,
  formatterFunc: null,
  fontSize: 12,
  isUnit: false,
};

export const DEFAULT_PROGRESS_PROPS: ColorProgressProps = {
  className: '',
  style: {},
  colours: DEFAULT_MAP_COLOR,
  values: null,
  isUnit: false,
  labelText: 'Project Number',
  direction: 'vertical',
};